export enum Langs {
    zh = "zh",
    en = "en",
    fr = "fr",
    de = "de",
    jp = "jp",
    es = "es",
    pt = "pt",
    it = "it",
    tw = "tw",
    ru = "ru",
    kr = "kr",
}

type MulLang = "zh" | "en" | "fr" | "de" | "jp" | "es" | "pt" | "it" | "tw" | "ru" | "kr";

type MulLanObj = {
    [key in MulLang]: string;
};

interface SearchLibraryItem extends MulLanObj {
    blob: Blob;
    hasControl: boolean;
    imgname: string;
    next: number;
    shape: string;
    table_id: number;
    table_index: number;
    url: string;
    name?: string;
}

export type SearchLibraryData = {
    groupName: string;
    id: number;
    isLibrary: boolean;
    showMore?: boolean;
    tableId: number;
    tableName: string;
    data: Array<SearchLibraryItem>;
    renderData: Array<SearchLibraryItem>;
};

export type MulLangWithName =
    | "zh_name"
    | "en_name"
    | "fr_name"
    | "de_name"
    | "jp_name"
    | "es_name"
    | "pt_name"
    | "it_name"
    | "tw_name"
    | "ru_name"
    | "kr_name";

type MulLanObjWithName = {
    [key in MulLangWithName]: string;
};

export interface LibraryItem extends MulLanObjWithName {
    blob: Blob;
    hasControl: boolean;
    name: string;
    next: number;
    shape: string;
    table_id: number;
    table_index: number;
    tempIMG: Array<string>;
    url: string;
    isVip?: boolean;
}

export interface RenderLibraryData extends Partial<MulLanObj> {
    data: Array<LibraryItem>;
    group: string;
    id: number;
    title: string;
}

type GroupName =
    | "groupName"
    | "groupName_zh"
    | "groupName_en"
    | "groupName_fr"
    | "groupName_de"
    | "groupName_jp"
    | "groupName_es"
    | "groupName_pt"
    | "groupName_it"
    | "groupName_tw"
    | "groupName_ru"
    | "groupName_kr";
type TableName =
    | "tableName"
    | "tableName_zh"
    | "tableName_en"
    | "tableName_fr"
    | "tableName_de"
    | "tableName_jp"
    | "tableName_es"
    | "tableName_pt"
    | "tableName_it"
    | "tableName_tw"
    | "tableName_ru"
    | "tableName_kr";
type DescriptionName =
    | "description"
    | "description_zh"
    | "description_en"
    | "description_fr"
    | "description_de"
    | "description_jp"
    | "description_es"
    | "description_pt"
    | "description_it"
    | "description_tw"
    | "description_ru"
    | "description_kr";

type TableNameObj = {
    [key in TableName]: string;
};
type MenuItemObj = {
    [key in DescriptionName | GroupName]: string;
};

export interface MenuItemChild extends Partial<TableNameObj> {
    checked: boolean;
    id: number;
    mcount: number;
    type: unknown;
    url: string;
    version: string;
    cloneID?: number;
    modifiedFromClone?: boolean;
    title: string; // 用于 template 里展示的
}

export interface MenuItem extends Partial<MenuItemObj> {
    checkedAll: boolean;
    checkedList: Array<number>;
    children: Array<MenuItemChild>;
    id: number;
    indeterminate: boolean;
    show: boolean;
    loaded?: boolean;
    title: string; // 用于 template 里展示的
}

type LibraryDisplayItem = {
    imgname: string;
    table_index: number;
    url: string;
};

export type DisplayListItem = {
    groupName: string;
    tableName: string;
    title: string;
    checked: boolean;
    id: number;
    data: Array<LibraryDisplayItem>;
};

export type LibraryDisplayList = {
    title: string;
    groupName: string;
    data: Array<DisplayListItem>;
};
export type LibraryDisplayListRecord = Record<string, LibraryDisplayList>;
